import { ChatBoxElement } from "./index";
import { runAgent } from "../agent/agent";
import retrieve_sales_forecast from "../agent/tools/retrieve_sales_forecast";
import retrieve_sales_goals from "../agent/tools/retrieve_sales_goals";
import retrieve_sales_actuals from "../agent/tools/retrieve_sales_actuals";
const SYSTEM_PROMPT = `You are a helpful assistant in FFP Area. You help the user to get insights about
    - Sales actuals
    - Sales forecast
    - Sales goals
    - Information about units

    You DO NOT ANSWER ANY QUESTIONS OUTSIDE OF THE SCOPE.
    If the user is asking questions outside of the scope, you should let the user know that you can't help with that.
    Instead ask following questions to collect information to better understand the user's intent
    for using your tools to answer with the right information. Do not answer questions about personal matters or anything out of scope.
    
    Today's date is 2025-03-05`;


export function glue(ui_element: ChatBoxElement) {
  console.log("Gluing chatbox", ChatBoxElement.events.PROMPT_SUBMIT, {
    ui_element,
  });
  ui_element.addEventListener(
    ChatBoxElement.events.PROMPT_SUBMIT,
    async (event: any) => {
      // Add user message to the chatbox history
      if (!event.detail.message) return;
      ui_element.messages = [
        ...ui_element.messages,
        CreateUserMessage(event.detail.message),
      ];
      const stopThinking = ui_element.think("Thinking...");
      // Infer the response from the agent
      const response = await runAgent({
        system: SYSTEM_PROMPT,
        messages: ui_element.messages as any,
        tools: {
          retrieve_sales_forecast,
          retrieve_sales_goals,
          retrieve_sales_actuals,
        },
      });
      stopThinking();
      // Add the assistant message to the chatbox history
      ui_element.messages = [
        ...ui_element.messages,
        CreateAssistantMessage(response.text),
      ];
    }
  );
}

function CreateUserMessage(message: string) {
  return { role: "user", content: message };
}
function CreateAssistantMessage(message: string) {
  return { role: "assistant", content: message };
}
